// TestSyncModal.jsx - Updated for Edit Listing
import React, { useEffect, useState } from "react";
import { LoaderCircle, X, Check, AlertCircle, Info } from 'lucide-react';
import apiHelper from '../apiHelper.js';
import AlertNotification from './AlertNotification'; // Import the AlertNotification component

const TestSyncModal = ({ isOpen, onClose, onConfirm, rows, setRows, selectedStock, listingId }) => {
    const [isProcessing, setIsProcessing] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [allDataFetched, setAllDataFetched] = useState(false);
    const [fetchErrors, setFetchErrors] = useState([]);
    const [abortController, setAbortController] = useState(null);
    const [limitExceededError, setLimitExceededError] = useState(null); // State for limit exceeded toast

    // Success SVG icon
    const SuccessIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.99967 1.3335C4.32367 1.3335 1.33301 4.32416 1.33301 8.00016C1.33301 11.6762 4.32367 14.6668 7.99967 14.6668C11.6757 14.6668 14.6663 11.6762 14.6663 8.00016C14.6663 4.32416 11.6757 1.3335 7.99967 1.3335ZM7.11631 10.4929C6.86809 10.7411 6.46571 10.7413 6.21722 10.4933L4.66331 8.94278C4.40281 8.68284 4.40228 8.26096 4.66213 8.00037C4.92215 7.73962 5.34435 7.73914 5.60496 7.99929L6.66567 9.05816L9.72367 6.00016C9.98398 5.73985 10.406 5.73985 10.6663 6.00016C10.9267 6.26047 10.9267 6.68252 10.6663 6.94283L7.11631 10.4929Z" fill="#146C43"/>
        </svg>
    );

    // Failed SVG icon
    const FailedIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.96834 1.3335C4.30967 1.3335 1.33301 4.32416 1.33301 8.00016C1.33301 11.6762 4.32367 14.6668 7.99967 14.6668C11.6757 14.6668 14.6663 11.6762 14.6663 8.00016C14.6663 4.32416 11.6617 1.3335 7.96834 1.3335ZM8.66634 10.6668C8.66634 11.035 8.36786 11.3335 7.99967 11.3335C7.63148 11.3335 7.33301 11.035 7.33301 10.6668C7.33301 10.2986 7.63148 10.0002 7.99967 10.0002C8.36786 10.0002 8.66634 10.2986 8.66634 10.6668ZM8.66634 8.00016C8.66634 8.36835 8.36786 8.66683 7.99967 8.66683C7.63148 8.66683 7.33301 8.36835 7.33301 8.00016V5.3335C7.33301 4.96531 7.63148 4.66683 7.99967 4.66683C8.36786 4.66683 8.66634 4.96531 8.66634 5.3335V8.00016Z" fill="#DC3545"/>
        </svg>
    );

    // Function to check if error is a limit exceeded error
    const isLimitExceededError = (error, platform, responseData) => {
        // For TikTok: error is true and code is 36009002 or 36009007
        if (platform && platform.toLowerCase().includes('tiktok')) {
            if (responseData && responseData.code) {
                return responseData.code === 36009002 || responseData.code === 36009007;
            }
        }
        
        // For Lazada: response contains {"error":"Max retries exceeded","code":"MaxRetriesExceeded"}
        if (platform && platform.toLowerCase().includes('lazada')) {
            if (error && error.message) {
                return error.message.includes('Max retries exceeded') || 
                       error.message.includes('MaxRetriesExceeded');
            }
            if (responseData && responseData.error === 'Max retries exceeded' && 
                responseData.code === 'MaxRetriesExceeded') {
                return true;
            }
        }
        
        return false;
    };

    // Function to abort all ongoing requests
    const handleAbort = () => {
        if (abortController) {
            abortController.abort();
            setAbortController(null);
        }
        // Call the same onClose function that close button uses
        onClose();
    };

    const fetchProductData = async (row, signal) => {
        try {
            if (row.platform.includes('Lazada')) {
                // Lazada API call - GET request using product_id only
                const response = await apiHelper(
                    `lazada/get-product/?item_id=${row.product_id}`,
                    "GET",
                    null,
                    { signal } // Pass signal to fetch options
                );
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                   
                }
                
                const data = await response.json();
                
                // Check for Lazada limit exceeded error
                if (data.error === 'Max retries exceeded' && data.code === 'MaxRetriesExceeded') {
                    const error = new Error('Limit exceeded. Remove some Listings to continue');
                    error.limitExceeded = true;
                    error.platform = 'Lazada';
                    throw error;
                }
                
                if (data.success) {
                    const productData = data.data;
                    console.log('productData>>>>>>',productData)
                    console.log('skuData>>>>>>',productData.skus,row.sku_id?.toString())
                    // Find the specific SKU in the skus array using sku_id (which is SkuId from response)
                    console.log("row.sku_id?.toString()<<<<",row.sku_id?.toString())
                    const skuData = productData.skus?.find(sku => 
                        sku.ShopSku?.toString() === row.sku_id?.toString()
                    );
                    
                    if (!skuData) {
                        return {
                            verified: false,
                            product_name: productData.attributes?.name || '-',
                            sku_name: 'Invalid ID',
                            product_price: '-',
                            prioduct_stock: '-',
                            loading: false,
                            hasError: true,
                            errorMessage: `SKU ID ${row.sku_id} not found in product ${row.product_id}`
                        };
                    }
                    
                    // Generate sku_name from saleProp values
                    let skuName = '-';
                    if (skuData.saleProp) {
                        // Get all values from saleProp object and join them with comma
                        const salePropValues = Object.values(skuData.saleProp);
                        if (salePropValues.length > 0) {
                            skuName = salePropValues.join(', ');
                        }
                    }
                    
                    return {
                        verified: true,
                        product_name: productData.attributes?.name || '-',
                        sku_name: skuName, // Now using saleProp values instead of SellerSku
                        product_price: skuData.price ? `SGD ${skuData.price}` : '-',
                        prioduct_stock: skuData.quantity?.toString() || '0',
                        loading: false,
                        hasError: false
                    };
                } else {
                    return {
                        verified: false,
                        product_name: 'Invalid ID',
                        sku_name: '-',
                        product_price: '-',
                        prioduct_stock: '-',
                        loading: false,
                        hasError: true,
                        errorMessage: data.message || 'Product not found on Lazada'
                    };
                }
            } else if (row.platform.includes('Shopee')) {
            console.log('Fetching Shopee product:', {
                platform: row.platform,
                product_id: row.product_id,
                sku_id: row.sku_id
            });
            
            // First API call - Get basic product info
            // Make sure we're sending a clean object
            const pro_id=row.product_id
            const payload = { 'item_id': pro_id };
            console.log('Shopee request payload:', payload);
            
            const response = await apiHelper(
                `shopee/get-product-info/?item_id=${row.product_id}`,
                'GET',
                null,
                { signal }
            );
            
            console.log('Shopee response status:', response.status);
            
            if (!response.ok) {
                const errorText = await response.text();
                console.error('Shopee API error response:', errorText);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('Shopee response data:', data);
            
            if (data.status === 'success' && data.data?.valid_items?.length > 0) {
                const productData = data.data.valid_items[0];
                console.log('Shopee product data:', productData);
                
                // If product has models, we need to fetch them separately
                if (productData.has_model) {
                    console.log('Product has models, fetching model list...');
                    
                    // Make another API call to get models/variations
                    const modelsPayload = { item_id: row.product_id };
                    console.log('Models request payload:', modelsPayload);
                    
                    const modelsResponse = await apiHelper(
                        `shopee/get-model-list/?item_id=${row.product_id}`,
                        'GET',
                        null,
                        { signal }
                    );
                    
                    console.log('Models response status:', modelsResponse.status);
                    
                    if (!modelsResponse.ok) {
                        throw new Error(`Failed to fetch models: ${modelsResponse.status}`);
                    }
                    
                    const modelsData = await modelsResponse.json();
                    console.log("Shopee models data:", modelsData);
                    
                    // Find the specific model using sku_id
                    let modelInfo = null;
                    if (modelsData.models && Array.isArray(modelsData.models)) {
                        modelInfo = modelsData.models.find(model => 
                            model.model_id?.toString() === row.sku_id?.toString()
                        );
                    }
                    console.log('Found modelInfo:', modelInfo);
                    
                    if (!modelInfo) {
                        return {
                            verified: false,
                            product_name: productData.item_name || '-',
                            sku_name: 'Invalid ID',
                            product_price: '-',
                            prioduct_stock: '-',
                            loading: false,
                            hasError: true,
                            errorMessage: `Model ID ${row.sku_id} not found in product ${row.product_id}`
                        };
                    }
                    
                    return {
                        verified: true,
                        product_name: productData.item_name || '-',
                        sku_name: modelInfo.model_name || modelInfo.model_sku || '-',
                        product_price: modelInfo.price_info ? `SGD ${modelInfo.price_info[0].current_price}` : '-',
                        prioduct_stock: modelInfo.stock_info?.seller_stock?.[0]?.stock?.toString() || '0',
                        loading: false,
                        hasError: false
                    };
                } else {
                    // Product has no models, use the main product info
                    console.log('Product has no models, using main product info');
                    
                    return {
                        verified: true,
                        product_name: productData.item_name || '-',
                        sku_name: productData.item_sku || '-',
                        product_price: productData.price_info?.current_price 
                            ? `SGD ${productData.price_info.current_price}` 
                            : '-',
                        prioduct_stock: productData.stock_info?.stock?.toString() || '0',
                        loading: false,
                        hasError: false
                    };
                }
            } else {
                console.error('Invalid Shopee response:', data);
                return {
                    verified: false,
                    product_name: 'Invalid ID',
                    sku_name: '-',
                    product_price: '-',
                    prioduct_stock: '-',
                    loading: false,
                    hasError: true,
                    errorMessage: data.message || 'Product not found on Shopee'
                };
            }
            } else if (row.platform.includes('Tiktok') || row.platform.includes('TikTok') || row.platform.includes('Tik Tok')) {
                console.log(`Fetching TikTok product: ${row.product_id}`);
                
                // TikTok API call - GET request using product_id only
                const response = await apiHelper(
                    `tiktok/products/${row.product_id}/`,
                    "GET",
                    null,
                    { signal } // Pass signal to fetch options
                );
                
                console.log('TikTok API response status:', response.status);
                
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('TikTok API error response:', errorText);
                    throw new Error(`TikTok API error! status: ${response.status}`);
                }
                
                const data = await response.json();
                console.log('TikTok API data received:', data);
                
                // Check for TikTok error response with code
                if (data.error === true && data.code) {
                    // Check for limit exceeded codes
                    if (data.code === 36009002 || data.code === 36009007) {
                        const error = new Error('Limit exceeded. Remove some Listings to continue');
                        error.limitExceeded = true;
                        error.platform = 'TikTok';
                        error.code = data.code;
                        throw error;
                    }
                    return {
                        verified: false,
                        product_name: 'Invalid ID',
                        sku_name: '-',
                        product_price: '-',
                        prioduct_stock: '-',
                        loading: false,
                        hasError: true,
                        errorMessage: data.message || 'TikTok API error'
                    };
                }
                
                // Check if we got a valid response
                if (!data || typeof data !== 'object') {
                    throw new Error('Invalid response from TikTok API');
                }
                
                // Find the specific SKU using sku_id
                let skuData = null;
                
                if (data.skus && Array.isArray(data.skus)) {
                    
                    skuData = data.skus.find(sku => 
                        sku.id?.toString() === row.sku_id?.toString()
                    );
                    
                    if (!skuData) {
                        return {
                            verified: false,
                            product_name: data.title || '-',
                            sku_name: 'Invalid ID',
                            product_price: '-',
                            prioduct_stock: '-',
                            loading: false,
                            hasError: true,
                            errorMessage: `SKU ID ${row.sku_id} not found in product ${row.product_id}`
                        };
                    }
                } else {
                    return {
                        verified: false,
                        product_name: 'Invalid ID',
                        sku_name: '-',
                        product_price: '-',
                        prioduct_stock: '-',
                        loading: false,
                        hasError: true,
                        errorMessage: 'No SKUs found for this TikTok product'
                    };
                }
                
                // Generate sku_name from sales_attributes value_name values
                let skuName = '-';
                if (skuData.sales_attributes && Array.isArray(skuData.sales_attributes) && skuData.sales_attributes.length > 0) {
                    // Extract all value_name values and join them with " - "
                    const attributeValues = skuData.sales_attributes
                        .map(attr => attr.value_name)
                        .filter(value => value && value.trim() !== ''); // Remove empty values
                    
                    if (attributeValues.length > 0) {
                        skuName = attributeValues.join(' - ');
                    }
                }
                
                // Extract price and stock
                const price = skuData.price?.sale_price || skuData.price?.tax_exclusive_price;
                const currency = skuData.price?.currency || 'SGD';
                
                let stockQuantity = 0;
                if (skuData.inventory && Array.isArray(skuData.inventory)) {
                    stockQuantity = skuData.inventory.reduce((sum, inv) => {
                        return sum + (parseInt(inv.quantity) || 0);
                    }, 0);
                }
                
                console.log('TikTok parsed data:', {
                    product_name: data.title,
                    sku_name: skuName,
                    sales_attributes: skuData.sales_attributes,
                    price: price ? `${currency} ${price}` : '-',
                    stock: stockQuantity
                });
                
                return {
                    verified: true,
                    product_name: data.title || '-',
                    sku_name: skuName, // Using sales_attributes values instead of seller_sku
                    product_price: price ? `${currency} ${price}` : '-',
                    prioduct_stock: stockQuantity.toString(),
                    loading: false,
                    hasError: false
                };
            }
            else if (row.platform.includes('WooCommerce') || row.platform.includes('Woocommerce')) {
                console.log('Fetching WooCommerce product:', {
                    platform: row.platform,
                    product_id: row.product_id,
                    sku_id: row.sku_id
                });

                // Step 1: Validate product_id
                const productResponse = await apiHelper(
                    `woocommerce/validate-product/?product_id=${row.product_id}&variation_id=${row.sku_id}`,
                    "GET",
                    null,
                    { signal }
                );

                if (!productResponse.ok) {
                    throw new Error(`HTTP error! status: ${productResponse.status}`);
                }

                const data = await productResponse.json();
                console.log('WooCommerce response data:', data);

                if (data.valid) {
                    return {
                        verified: true,
                        product_name: data.product_name || '-',
                        sku_name: data.sku_name || '-',
                        product_price: data.price ? `SGD ${data.price}` : '-',
                        prioduct_stock: data.stock_quantity?.toString() || '0',
                        loading: false,
                        hasError: false
                    };
                } else {
                    // Distinguish product invalid vs variation invalid
                    // product_valid=false means product_id is wrong
                    // product_valid=true but variation_valid=false means sku_id is wrong
                    const productInvalid = data.product_valid === false;

                    return {
                        verified: false,
                        product_name: productInvalid ? 'Invalid ID' : (data.product_name || '-'),
                        sku_name: productInvalid ? '-' : 'Invalid ID',
                        product_price: '-',
                        prioduct_stock: '-',
                        loading: false,
                        hasError: true,
                        errorMessage: data.error || 'Invalid WooCommerce Product ID or Variation ID'
                    };
                }
            }
            else {
                throw new Error('Unknown platform');
            }
        } catch (error) {
            // Don't treat abort as an error to display to user
            if (error.name === 'AbortError') {
                console.log('Fetch aborted for', row.platform);
                // Return a special state for aborted requests
                return {
                    verified: false,
                    product_name: 'Request aborted',
                    sku_name: 'Request aborted',
                    product_price: '-',
                    prioduct_stock: '-',
                    loading: false,
                    hasError: false, // Don't show as error since user aborted
                    aborted: true
                };
            }
            
            console.error(`Error fetching data for ${row.platform}:`, error);
            console.error('Row data:', row);
            
            // Check if this is a limit exceeded error
            if (error.limitExceeded) {
                // Set the limit exceeded toast message
                setLimitExceededError({
                    message: error.message,
                    platform: error.platform,
                    code: error.code
                });
            }
            
            return {
                verified: false,
                product_name: 'Invalid ID',
                sku_name: '-',
                product_price: '-',
                prioduct_stock: '-',
                loading: false,
                hasError: true,
                errorMessage: error.limitExceeded ? error.message : error.message
            };
        }
    };

    // Helper function to safely parse numeric values
    const parsePrice = (priceString) => {
        if (!priceString || priceString === '-' || priceString === 'Invalid ID') {
            return null;
        }
        
        try {
            // Remove currency symbol and any non-numeric characters except decimal point
            const numericString = priceString.replace(/[^\d.-]/g, '');
            const parsed = parseFloat(numericString);
            return isNaN(parsed) ? null : parsed;
        } catch (error) {
            console.error('Error parsing price:', error);
            return null;
        }
    };

    // Helper function to safely parse stock quantity
    const parseStockQuantity = (stockString) => {
        if (!stockString || stockString === '-' || stockString === 'Invalid ID') {
            return 0;
        }
        
        try {
            // Remove any non-numeric characters
            const numericString = stockString.replace(/[^\d]/g, '');
            const parsed = parseInt(numericString, 10);
            return isNaN(parsed) ? 0 : parsed;
        } catch (error) {
            console.error('Error parsing stock quantity:', error);
            return 0;
        }
    };

    const saveTestResults = async (fetchedRows) => {
        if (!listingId) {
            console.error('No listing ID available');
            return false;
        }
        
        setIsSaving(true);
        
        try {
            // Filter rows that have platform, product_id, and sku_id and weren't aborted
            const validRows = fetchedRows.filter(row => 
                row.platform && row.product_id && row.sku_id && !row.aborted
            );
            
            if (validRows.length === 0) {
                setIsSaving(false);
                return false;
            }
            
            // Prepare data for saving with safe parsing
            const platformMappings = validRows.map(row => {
                const mappingData = {
                    platform: row.platform,
                    product_id: row.product_id,
                    sku_id: row.sku_id,
                    platform_product_name: row.product_name || '',
                    platform_sku_name: row.sku_name || '',
                    test_status: row.hasError ? 'failed' : 'success',
                    error_message: row.errorMessage || (row.hasError ? 'Invalid ID or API error' : ''),
                    mapping_id: row.mapping_id // Include mapping_id if exists (for existing mappings)
                };
                
                // Safely parse price if available
                if (row.product_price && row.product_price !== '-' && row.product_price !== 'Invalid ID') {
                    const parsedPrice = parsePrice(row.product_price);
                    if (parsedPrice !== null) {
                        mappingData.platform_price = parsedPrice;
                    }
                }
                
                // Safely parse stock quantity if available
                if (row.prioduct_stock && row.prioduct_stock !== '-' && row.prioduct_stock !== 'Invalid ID') {
                    const parsedStock = parseStockQuantity(row.prioduct_stock);
                    mappingData.platform_stock_quantity = parsedStock;
                } else {
                    mappingData.platform_stock_quantity = 0;
                }
                
                return mappingData;
            });
            
            const payload = {
                platform_mappings: platformMappings
            };
            
            const response = await apiHelper(
                `sales/listings/${listingId}/test-sync/save/`,
                'POST',
                payload
            );
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to save test results');
            }
            
            const result = await response.json();
            console.log('Test results saved:', result);
            
            return true;
            
        } catch (error) {
            console.error('Error saving test results:', error);
            setFetchErrors(prev => [...prev, error.message]);
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        if (!isOpen) return;
        
        // Reset states when modal opens
        setAllDataFetched(false);
        setIsProcessing(true);
        setFetchErrors([]);
        setLimitExceededError(null); // Reset limit exceeded error
        
        // Create new AbortController for this fetch operation
        const controller = new AbortController();
        setAbortController(controller);
        const { signal } = controller;
        
        // Set all rows to loading state
        setRows(prev =>
            prev.map(row => ({
                ...row,
                loading: true,
                verified: false,
                hasError: false,
                product_name: '',
                sku_name: '',
                product_price: '',
                prioduct_stock: ''
            }))
        );

        // Fetch data for all rows
        const fetchAllData = async () => {
            const updatedRows = [];
            const errors = [];
            
            for (const row of rows) {
                // Check if aborted before each request
                if (signal.aborted) {
                    console.log('Fetch aborted by user');
                    break;
                }
                
                // Only fetch for rows with platform, product_id, and sku_id
                if (row.platform && row.product_id && row.sku_id) {
                    try {
                        const result = await fetchProductData(row, signal);
                        updatedRows.push({
                            ...row,
                            ...result
                        });
                    } catch (error) {
                        // Don't add errors for aborted requests
                        if (error.name !== 'AbortError') {
                            errors.push(`${row.platform}: ${error.message}`);
                            updatedRows.push({
                                ...row,
                                loading: false,
                                verified: false,
                                hasError: true,
                                product_name: 'API Error',
                                sku_name: 'API Error',
                                product_price: '-',
                                prioduct_stock: '-',
                                errorMessage: error.message
                            });
                        }
                    }
                } else {
                    // For rows without required data
                    errors.push(`${row.platform || 'Unknown'}: Missing required fields`);
                    updatedRows.push({
                        ...row,
                        loading: false,
                        verified: false,
                        hasError: true,
                        product_name: 'Invalid ID',
                        sku_name: 'Invalid ID',
                        product_price: '-',
                        prioduct_stock: '-',
                        errorMessage: 'Missing required fields: platform, product_id, or sku_id'
                    });
                }
            }
            
            // Only update if not aborted
            if (!signal.aborted) {
                // Update all rows at once
                setRows(updatedRows);
                setFetchErrors(errors);
                setIsProcessing(false);
                setAllDataFetched(true);
                
                // Automatically save test results after all data is fetched
                // if (updatedRows.length > 0 && listingId) {
                //     setTimeout(() => {
                //         saveTestResults(updatedRows);
                //     }, 500); // Small delay to ensure UI updates first
                // }
            }
            
            // Clean up abort controller
            setAbortController(null);
        };

        fetchAllData();

        // Cleanup function to abort fetch if component unmounts or modal closes
        return () => {
            if (controller) {
                controller.abort();
                setAbortController(null);
            }
        };
    }, [isOpen, listingId]);

    const handleDoneClick = () => {
        onConfirm();
    };

    const handleCloseToast = () => {
        setLimitExceededError(null);
    };

    if (!isOpen) return null;

    return (
        <>
            <div
                className="drawer-overlay"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1040,
                }}
                onClick={onClose}
            />
            <div
                className="entity-drawer modal-popup-cls"
                style={{
                    maxWidth: 872,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                }}
            >
                {/* Use AlertNotification for limit exceeded toast */}
                {limitExceededError && (
                    <AlertNotification
                        type="error"
                        recordName="Listing"
                        action="update"
                        message={limitExceededError.message}
                        onClose={handleCloseToast}
                    />
                )}

                {/* Header */}
                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                {/* Title */}
                <h3
                    style={{
                        textAlign: "left",
                        color: "#212529",
                        fontSize: "20px",
                        fontWeight: "600",
                        lineHeight: "24px",
                        fontFamily: "Montserrat",
                        marginBottom: "20px",
                    }}
                >
                    Test Sync
                </h3>

                {/* Error summary */}
                {fetchErrors.length > 0 && (
                    <div 
                        className="alert alert-warning"
                        style={{
                            marginBottom: '15px',
                            padding: '10px 15px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            fontSize: '12px',
                            backgroundColor: '#fff3cd',
                            borderColor: '#ffecb5',
                            color: '#997404'
                        }}
                    >
                        <AlertCircle size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
                        <div>
                            <strong>Some platforms could not be verified:</strong>
                            <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px' }}>
                                {fetchErrors.slice(0, 3).map((error, idx) => (
                                    <li key={idx}>{error}</li>
                                ))}
                                {fetchErrors.length > 3 && (
                                    <li>...and {fetchErrors.length - 3} more errors</li>
                                )}
                            </ul>
                        </div>
                    </div>
                )}

                {/* Description */}
                <div className="new-look">
                    <div className="entities-tab test-sync" style={{ padding: 0 }}>
                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                            <table className="entities-table tab-table w-100">
                                <thead height="45px">
                                    <tr>
                                        <th style={{padding:"10px"}}><span>Platform</span></th>
                                        <th style={{padding:"10px"}}><span>Product Name</span></th>
                                        <th style={{padding:"10px"}}><span>SKU Name</span></th>
                                        <th style={{padding:"10px"}}><span>Platform Price</span></th>
                                        <th style={{padding:"10px"}}><span>Platform Stock</span></th>
                                        {/* <th><span>Status</span></th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                {r.loading ? (
                                                    <LoaderCircle className="loading" size={16} style={{ animation: 'spin 1s linear infinite' }} />
                                                ) : r.verified && !r.hasError ? (
                                                    <SuccessIcon />
                                                ) : r.hasError ? (
                                                    <FailedIcon />
                                                ) : null}
                                                &nbsp;&nbsp;
                                                {r.platform || 'No platform selected'}
                                            </td>
                                            <td style={{ color: r.product_name === 'Invalid ID' ? '#DC3545' : 'inherit' }}>
                                                {r.product_name}
                                            </td>
                                            <td style={{ color: (r.sku_name === 'Invalid ID' || r.product_name === 'Invalid ID') ? '#DC3545' : 'inherit' }}>
                                                {(r.sku_name === 'Invalid ID' || r.product_name === 'Invalid ID') ? 'Invalid ID' : r.sku_name}
                                            </td>
                                            <td>{r.product_price}</td>
                                            <td>{r.prioduct_stock}</td>
                                            {/* <td>
                                                {r.loading ? (
                                                    <span style={{ color: '#6C757D', fontSize: '12px' }}>Fetching...</span>
                                                ) : r.hasError ? (
                                                    <span style={{ color: '#DC3545', fontSize: '12px' }}>Failed</span>
                                                ) : r.aborted ? (
                                                    <span style={{ color: '#6C757D', fontSize: '12px' }}>Aborted</span>
                                                ) : (
                                                    <span style={{ color: '#146C43', fontSize: '12px' }}>Verified</span>
                                                )}
                                            </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="drawer-footer" style={{ 
                    paddingTop: "10px", 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center" 
                }}>
                    <div style={{ fontSize: '12px', color: '#6C757D' }}>
                        {/* {rows.filter(r => !r.hasError && r.verified && !r.aborted).length} of {rows.length} mappings verified
                        {isSaving && ' • Saving...'} */}
                    </div>
                    {isProcessing ? (
                        <button 
                            className="btn dark-button" 
                            onClick={handleAbort}
                            style={{ 
                                display: "flex",
                                height: "34px",
                                minWidth: "100px",
                                padding: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "8px",
                                background: "#212529",
                                color:"white",
                                boxShadow:" 0 1px 4px 0 rgba(0, 0, 0, 0.10)",
                            }}
                        >
                            Abort
                        </button>
                    ) : (
                        <button 
                            className="btn-save" 
                            onClick={handleDoneClick}
                            style={{ 
                                opacity: 1,
                                cursor: 'pointer'
                            }}
                        >
                            Done
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default TestSyncModal;